import { ReactComponent as ListIcon } from "assets/List.svg";
import { ReactComponent as PropertyIcon } from "assets/Property.svg";
import { ReactComponent as UserCircleSmall } from "assets/UserCircleSmall.svg";
import PlansIconNew from "./PlansIcon";

export const recentlyViewedDataCorpUser: { [key: string]: any } = {
  user: {
    title: "Users",
    Icon: UserCircleSmall,
    key1: "displayName",
    key2: "innCodes",
    url1: "userview",
    url2: "hltId",
    queryParam: { key: "inncode", val: "innCodes", index: 0 }
  },
  cmsPlan: { title: "Plans", Icon: PlansIconNew, key1: "name", key2: null, url1: "plandetails", url2: "cmsId" },
  property: {
    title: "Properties",
    Icon: PropertyIcon,
    key1: "name",
    key2: "innCode",
    url1: "property",
    url2: "innCode"
  },
  myList: { title: "Lists", Icon: ListIcon, key1: "name", key2: null, url1: "myLists" }
};

export const recentlyViewedDataHotelUser: { [key: string]: any } = {
  cmsPlan: { title: "Library Plans", Icon: PlansIconNew, key1: "name", key2: null, url1: "plandetails", url2: "cmsId" },
  propertyPlan: {
    title: "My Plans & Property Plans",
    Icon: PlansIconNew,
    key1: "name",
    key2: null,
    url1: "myplandetails",
    url2: "propertyPlanId"
  }
};

export const getUrl = (key: string = "user", el: any, recentlyViewedData: any) => {
  const url1 = recentlyViewedData[key].url1;
  const url2 = recentlyViewedData[key].url2;
  const queryParams = recentlyViewedData[key].queryParam;

  let targetUrl = `/${url1}`;
  if (url2) targetUrl = targetUrl + `/${el[url2]}`;
  if (queryParams) targetUrl = targetUrl + `?${queryParams.key}=${el[queryParams.val][queryParams.index] ?? ""}`;
  return targetUrl;
};
